import './style/index.js';

import _Image from './Image';

export type { ImageProps } from './Image';

export const Image = _Image;

export default Image;
